export enum EmailEventType {
    AlarmRaised,
    Approval,
    Rejection,
    TicketStatuses
}